import React from "react";
import { useI18n } from "../lib/i18n";
import { Building2, Hash, Globe, ShieldCheck, Mail, MapPin, UserPlus } from "lucide-react";
import { REGISTER_URL } from "../lib/config";

export default function Company() {
  const { lang } = useI18n();
  const it = lang === "it";

  return (
    <div className="wc-container wc-company" data-testid="company-page">
      <span className="wc-eyebrow">{it ? "Azienda" : "Company"}</span>
      <h1 className="wc-title">Wordcripto Unipessoal LDA</h1>
      <p className="wc-lead">
        {it
          ? "Piattaforma di arbitraggio automatizzato con intelligenza artificiale. Trasparenza, gestione del rischio, evoluzione continua."
          : "Automated arbitrage platform powered by artificial intelligence. Transparency, risk management, continuous evolution."}
      </p>

      <div className="wc-company-grid">
        <div className="wc-company-card">
          <div className="wc-company-icon"><Building2 /></div>
          <div>
            <span className="wc-company-label">{it ? "Ragione sociale" : "Legal name"}</span>
            <p className="wc-company-value" data-testid="company-legal-name">Wordcripto Unipessoal LDA</p>
          </div>
        </div>

        <div className="wc-company-card">
          <div className="wc-company-icon"><Hash /></div>
          <div>
            <span className="wc-company-label">{it ? "Numero registro" : "Company number"}</span>
            <p className="wc-company-value" data-testid="company-number">519515471</p>
          </div>
        </div>

        <div className="wc-company-card">
          <div className="wc-company-icon"><Globe /></div>
          <div>
            <span className="wc-company-label">{it ? "Sito ufficiale" : "Official site"}</span>
            <p className="wc-company-value">
              <a href="https://wordcripto.com" target="_blank" rel="noreferrer" data-testid="company-site">wordcripto.com</a>
            </p>
          </div>
        </div>

        <div className="wc-company-card">
          <div className="wc-company-icon"><MapPin /></div>
          <div>
            <span className="wc-company-label">{it ? "Sede" : "Headquarters"}</span>
            <p className="wc-company-value">Portugal</p>
          </div>
        </div>

        <div className="wc-company-card wc-company-card-wide">
          <div className="wc-company-icon"><ShieldCheck /></div>
          <div>
            <span className="wc-company-label">{it ? "Certificazioni" : "Certifications"}</span>
            <p className="wc-company-value">
              {it
                ? "In arrivo. Verranno pubblicate qui non appena disponibili."
                : "Coming soon. Will be published here as soon as available."}
            </p>
          </div>
        </div>

        <div className="wc-company-card wc-company-card-wide">
          <div className="wc-company-icon"><Mail /></div>
          <div>
            <span className="wc-company-label">{it ? "Contatti" : "Contact"}</span>
            <p className="wc-company-value">
              <a href="https://wordcripto.com" target="_blank" rel="noreferrer">wordcripto.com</a>
            </p>
          </div>
        </div>
      </div>

      <div className="wc-company-note">
        <p>
          {it
            ? "I dati contenuti in questa applicazione hanno scopo puramente illustrativo. La simulazione riflette le regole del prodotto WordCripto ma non costituisce garanzia di rendimento."
            : "The information in this app is illustrative only. The simulation reflects the WordCripto product rules but is not a guarantee of returns."}
        </p>
      </div>

      <a
        href={REGISTER_URL}
        target="_blank"
        rel="noreferrer"
        className="wc-cta-banner"
        data-testid="company-register-cta"
      >
        <div className="wc-cta-copy">
          <span className="wc-eyebrow">
            {it ? "Iscrizione ufficiale" : "Official signup"}
          </span>
          <h3 className="wc-cta-title">
            {it
              ? "Crea il tuo account su wordcripto.com"
              : "Create your account on wordcripto.com"}
          </h3>
          <p className="wc-cta-note">
            {it
              ? "Referral: GianniSarti · Versamento minimo $500."
              : "Referral: GianniSarti · Minimum deposit $500."}
          </p>
        </div>
        <div className="wc-cta-btn">
          <UserPlus size={18} />
          <span>{it ? "Iscriviti ora" : "Sign up now"}</span>
        </div>
      </a>
    </div>
  );
}
